import { InteractionRequiredAuthError    } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";

export const useMsalToken = () => {
    const { instance } = useMsal();

    const acquireToken = useCallback(async () => {
        if (!instance) return;

        const request = {
            scopes: ["openid", "profile", "User.Read"]
        }

        await instance.initialize();

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.idToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect(request);
            }
        }
    }, [instance]);

    return {
        acquireToken
    }
};
